import { useNavigate, useParams } from "react-router";
import ProfileDropdown from "../components/ProfileDropDown";
import { useEffect, useState } from "react";
import { useApp } from "../Context";
import BottomSheet from "../components/BottomSheet";

export default function Header() {
    const navigate = useNavigate();
    const {getCfg, table, setTable, unpaid} = useApp();

    const [name, setName] = useState(() => {
        return getCfg().text
    });
    //const [unpaid, setUnpaid] = useState(false)

    useEffect(() => {
        if (!name) {
            getCfg().then((item) => {
                setName(item.text);
            });
        }
    }, [name]);

    /*
    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("orderids")) || {};
        const items = stored[restaurant] || [];

        const value = items.some(item =>
            typeof item === "object" && item !== null && item.paid === false
        );
        setUnpaid(value)
    }, [navigate]);
*/
    return (
        <div
            className="d-flex align-items-center justify-content-between px-3 py-2"
            style={{
                height: "50px",
                position: "fixed",
                top: 0,
                width: "100%",
                maxWidth: "500px",
                zIndex: 1050,
                backgroundColor: "var(--bs-header-bg)",
            }}
        >
            {/* Table Number Badge (Left Side) */}
            <div className="d-flex align-items-center" style={{minWidth: "90px"}}>
                {table && (table !== "pick" && table !== "PICK") &&
                    <span
                        className="btn btn-primary btn-sm rounded-pill fw-semibold px-3 py-1 shadow-sm primaryText"
                        onClick={() => {
                            setTable(null)

                        }}
                    >
                        {table ? `Bord ${table}` : "Inget bord"}
                    </span>
                }

            </div>

            {/* Centered Restaurant Name */}
            <h5 className="m-0 text-center flex-grow-1 fw-bold" style={{color: "var(--bs-headerText)"}} onClick={() => navigate("order")}>
                {name ?? "Laddar... 1"}
            </h5>

            {/* Profile Icon (Right Side) */}
            <div
                className="d-flex justify-content-end align-items-center"
                style={{minWidth: "70px"}}
                onClick={() => navigate("profile")}
            >
                <button
                    className="btn border-0 bg-transparent py-1 px-2 position-relative"
                    type="button"
                    style={{cursor: "pointer", color: "var(--bs-headerText)"}}
                >
                    <i className="bi bi-clock-history fs-3 fw-bold"></i>

                    {unpaid && (
                        <span
                            className="position-absolute bg-primary primaryText rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "18px",
                                height: "18px",
                                top: "6px",
                                right: "6px",
                                transform: "translate(25%, -25%)",
                                boxShadow: "0 0 3px rgba(0,0,0,0.2)"
                            }}
                            title="Unpaid orders"
                        >
        <i className="bi bi-exclamation-triangle-fill" style={{fontSize: "12px", lineHeight: 1, marginBottom: "2px"}}></i>
      </span>
                    )}
                </button>
            </div>
        </div>
    );
}
